import {
  EXTENSION_NORMALIZATION_MAP,
  SUPPORTED_IMAGE_TYPES,
  SUPPORTED_DOCUMENT_TYPES,
} from '@packages/shared/constants/Assets';

export const normalizeExtension = (extension: string): string =>
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly jpeg: "jpg"; }'.
  EXTENSION_NORMALIZATION_MAP[extension] || extension;

export const getNormalizedExtension = (name: string): string => {
  const extensionMatch = name.match(/\.([^.]*$)/);

  return extensionMatch
    ? // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
      normalizeExtension(extensionMatch[1].toLowerCase())
    : '';
};

export const isDocument = (fileName: string): boolean =>
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly pdf: RegExp; readonly doc: RegExp; readonly xls: RegExp; readonly ppt: RegExp; readonly docx: RegExp; readonly xlsx: RegExp; ... 7 more ...; readonly lottie: RegExp; }'.
  Boolean(SUPPORTED_DOCUMENT_TYPES[getNormalizedExtension(fileName)]);

export const isImage = (fileName: string): boolean => {
  const extension = getNormalizedExtension(fileName);
  return Boolean(
    SUPPORTED_IMAGE_TYPES[extension as keyof typeof SUPPORTED_IMAGE_TYPES]
  );
};
